// Bag sets (BundleId "BB-…") merged by Cart Transform share one line key; removing it drops a single child line, so repeat
class BagSetRemove extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this._onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
  }

  _onClick = async (event) => {
    if (!event.target.closest("a") || this._busy) return;
    event.preventDefault();
    this._busy = true;

    this.closest("line-item")?.dispatchEvent(
      new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity: 0 } })
    );

    try {
      await this._removeSets();
    } catch (error) {
      console.error("[BagSetRemove] Failed:", error);
    }

    this._busy = false;
    if (window.themeVariables?.settings?.pageType === "cart") window.location.reload();
    else document.dispatchEvent(new CustomEvent("cart:refresh"));
  };

  async _removeSets() {
    const parentId = Number(this.dataset.parentVariantId);
    const parentGid = `gid://shopify/ProductVariant/${parentId}`;
    const root = window.Shopify?.routes?.root || "/";
    const getCart = () => fetch(`${root}cart.js`, { headers: { Accept: "application/json" } }).then((res) => res.json());
    // change.js / update.js answer with unmerged child lines, zero-quantity ones included, so re-read /cart.js
    const post = (path, body) =>
      fetch(`${root}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then((res) => {
        if (!res.ok) throw new Error(`${path} answered ${res.status}`);
        return getCart();
      });
    const parentTotal = (cart) =>
      cart.items.filter((item) => item.variant_id === parentId).reduce((sum, item) => sum + item.quantity, 0);

    let cart = await getCart();
    const target = parentTotal(cart) - Number(this.dataset.quantity);

    // Each pass removes one child line; the cap only guards against a cart that never converges
    for (let pass = 0; pass < 100; pass++) {
      const orphans = cart.items.filter((item) => item.quantity > 0 && item.properties?._bundleParentId === parentGid);
      if (orphans.length) {
        cart = await post("cart/update.js", { updates: Object.fromEntries(orphans.map((item) => [item.key, 0])) });
        continue;
      }

      const parentLine = cart.items.find((item) => item.variant_id === parentId);
      const before = parentTotal(cart);
      if (!parentLine || before <= target) {
          return;
      }
      cart = await post("cart/change.js", { id: parentLine.key, quantity: 0 });
      if (parentTotal(cart) >= before) throw new Error("cart/change.js did not lower the parent quantity");
    }
  }
}

if (!window.customElements.get("bag-set-remove")) {
  window.customElements.define("bag-set-remove", BagSetRemove);
}
